<template>
  <div class="active-flyers">
    <mf-loading-dialog :loading="loading">
      <div>
        <v-layout>
          <span v-if="!canSelectFlyers" class="card_title"
            >Exibindo {{ flyers.length }} encarte(s) ativos
            <span id="label-date" class="select-date" @click="openDatePicker">
              {{ formatDate() }}
            </span>
            <date-picker :date.sync="filters.date" solo hideInput class="select-date" />
            <!-- @input="getData" -->
          </span>

          <v-spacer />

          <mf-button v-if="!canSelectFlyers" id="create-new-flyer" label="Novo encarte" icon="add" @click="redirectToCreateNewFlyer" />
        </v-layout>

        <v-slide-group v-model="model" class="flyers-slide" show-arrows active-class="selected-flyer">
          <v-card v-if="!canSelectFlyers" class="card-new-flyer" @click="redirectToCreateNewFlyer">
            <div class="flyer-information">
              <mf-icon color="marca-0-l20" :size="40">assignment_add</mf-icon>
              <p>Clique para cadastrar um novo encarte</p>
            </div>
          </v-card>
          <v-slide-item v-for="(flyer, index) in flyers" :id="'flyer-' + index" :key="flyer.id" v-slot:default="{ active, toggle }">
            <v-card
              color="cinza-l90"
              class="ma-4"
              :class="[canSelectFlyers ? 'select-flyers' : 'flyer-card', isSelectedFlyer(flyer._id) ? 'selected-flyer' : '']"
              @click="toggle"
            >
              <div @click="selectItem(flyer)">
                <div class="image-container">
                  <v-img :loading="loading" :src="flyer.images[0]" :height="318" />
                </div>
                <div class="flyer-details">
                  <p class="flyer-title">{{ flyer.title }}</p>
                  <span class="flyer-period"
                    >{{ DateTime.fromISO(flyer.initial_date).toFormat('dd/MM/yyyy') }} - {{ DateTime.fromISO(flyer.final_date).toFormat('dd/MM/yyyy') }}</span
                  >
                </div>
                <v-scale-transition> </v-scale-transition>
              </div>
            </v-card>
          </v-slide-item>
        </v-slide-group>
      </div>
    </mf-loading-dialog>
  </div>
</template>

<script>
import { QUERY_FLYERS } from '../../graphql'
import DatePicker from '@/components/DatePicker.vue'
import { DateTime } from 'luxon'

export default {
  components: { DatePicker },
  props: {
    canSelectFlyers: {
      type: Boolean,
      default: false,
    },
    closeModal: {
      type: Boolean,
      default: false,
    },
    units: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    flyers: [],
    model: null,
    multiple: false,
    mandatory: false,
    showArrows: true,
    prevIcon: false,
    nextIcon: false,
    centerActive: false,
    indexScroll: 0,
    dateFilter: '',
    activeFlyers: [],
    filters: {
      date: '',
    },
    dialog: {},
    selectedFlyer: null,
    loading: true,
    DateTime: DateTime,
  }),
  computed: {
    isFranchise() {
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      return this.$getLoggedUser().is_franchisee
    },
  },

  async mounted() {
    if (!this.canSelectFlyers) {
      this.filters.date = DateTime.now().toFormat('yyyy-MM-dd')
    }

    await this.getFlyers()
  },
  methods: {
    async getFlyers() {
      try {
        const variables = {
          status: ['ACTIVE', 'SCHEDULED'],
          franchise: this.isFranchisee,
          only_franchise: this.isFranchise,
          units: this.units.map((unit) => unit.id_erp),
        }

        if (this.filters.date) variables.date = this.filters.date

        const {
          data: { flyers },
        } = await this.$apollo.query({
          query: QUERY_FLYERS,
          variables,
          fetchPolicy: 'no-cache',
        })

        if (flyers.flyers !== undefined) {
          this.flyers = flyers.flyers
        } else {
          this.flyers = []
        }
      } catch (error) {
        console.log(error)
        this.$snackbar({ message: 'Erro ao buscar dados no servidor', snackbarColor: 'error' })
      } finally {
        this.loading = false
      }
    },
    clearSelectedFlyer() {
      if (this.closeModal) this.selectedFlyer = null
      return null
    },
    openDatePicker() {
      document.querySelector('#date-picker-icon').click()
    },

    formatDate() {
      if (this.filters.date === DateTime.now().toFormat('yyyy-MM-dd')) return 'hoje'
      else return DateTime.fromISO(this.filters.date).toFormat('dd/MM/yyyy')
    },

    getNextTarget() {
      if (!(this.flyers.length < this.indexScroll + 1) || !(this.flyers.length === this.indexScroll)) this.indexScroll += 1
    },

    getPrevTarget() {
      if (!(this.flyers.length > this.indexScroll - 1) || !(this.indexScroll === 0)) this.indexScroll -= 1
    },

    disableNextScroll() {
      const flyerContainer = document.querySelector('.flyers-container')
      if (!flyerContainer) return false
      else {
        if (flyerContainer.clientWidth > 1100 && this.indexScroll === this.flyers.length - 4) return true
        if (flyerContainer.clientWidth < 1100 && this.indexScroll === this.flyers.length - 3) return true
      }
    },

    redirectToCreateNewFlyer() {
      this.$router.push('/mobile/encartes/novo').catch(() => {})
    },

    selectItem(flyer) {
      if (this.canSelectFlyers) {
        this.selectedFlyer = flyer
        this.$emit('selected-flyer', flyer)
      } else {
        if (flyer.status === 'ACTIVE') this.$router.push(`/mobile/encartes/resultados/${flyer._id}`).catch(() => {})
        else this.$router.push(`/mobile/encartes/editar/${flyer._id}`).catch(() => {})
      }
    },

    isSelectedFlyer(flyerId) {
      return !this.clearSelectedFlyer() && this.selectedFlyer && this.selectedFlyer._id === flyerId && this.canSelectFlyers
    },
  },
}
</script>

<style lang="scss">
.active-flyers {
  &::-webkit-scrollbar {
    width: 0px !important;
  }

  .flyer-card {
    padding: 15px 14px 24px !important;
    height: 416px;
    width: 280px;
    border-radius: 8px;
    background-color: $cinza-l80 !important;
    margin: 43px 8px 0 !important;
    .image-container {
      height: 318px;
    }
  }

  .select-flyers {
    @extend .flyer-card;
    cursor: pointer;
    &:hover {
      border: 1px $marca-0-l40 solid !important;
    }
  }

  .flyers-slide {
    padding: 0 12px 23px;
  }

  .selected-flyer {
    border: 1px $marca-1 solid !important;

    &:hover {
      border: 1px $marca-1 solid !important;
    }
  }

  .flyer-details {
    padding: 0 8px;

    .flyer {
      &-title {
        font-size: 18px;
        color: $cinza-d10;
        line-height: 120%;
        margin: 11px 0 7px;
        max-width: 300px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &-period {
        text-align: center;
        font-size: 16px;
        line-height: 120%;
        letter-spacing: 0.4px;
        color: $cinza-0;
      }

      &-units-content {
        margin-bottom: 10px;
      }
    }
  }

  .card-new-flyer {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 416px;
    width: 280px;
    background: white;
    border: 1px solid $marca-0-l20;
    margin: 43px 8px 0 !important;
    padding: 15px 14px 24px;
    text-align: center;
    cursor: pointer;

    .flyer-information {
      padding: 0 30px;
      p {
        font-size: 18px;
        font-weight: 400;
        line-height: 22px;
        text-align: center;
        color: $marca-0-l20;
        padding-top: 20px;
      }
    }
    .xl-icon {
      font-size: 84px;
    }
  }
  .flyers-layout {
    display: inline-flex;
  }
}

.card_title {
  user-select: none;
  color: $cinza-d10;
  display: inherit;
  font-size: 26px;
  font-weight: 700;
  line-height: 31px;

  > .select-date {
    color: $marca-0-l40;
    cursor: pointer;
    i {
      color: $marca-0-l40;
    }
  }

  > #label-date {
    margin-left: 5px;
  }
}

.see-all {
  margin-left: 5px;
  font-size: 12px;
  color: $marca-0-l40;
}
</style>
